import { atom } from 'jotai'
import { TProductCredit } from '../types'

export const productCreditState = atom<TProductCredit>({
    ushopCountryCode: '',
    baId: '',
    creditType: '',
    currency: '',
    availableBalance: 0,
    hydra: {
        log_id: null,
        duration: '',
        items: []
    }
})

export const loadProductCreditState = atom(false)
export const isProductCreditReadyState = atom(false)
export const isReadyState = atom(false)
